import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export enum AlertDialogResult {
  OK,
  CANCEL,
}

interface Props {
  isOpen: boolean;
  titleText?: string;
  contentText?: string;
  okBtnText?: string;
  cancelBtnText?: string;
  onClose: (result: AlertDialogResult) => void;
}

export function AlertDialog(props: Props) {
  const { isOpen, titleText, contentText, okBtnText, cancelBtnText, onClose } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={() => onClose(AlertDialogResult.CANCEL)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{titleText}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{contentText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(AlertDialogResult.OK)} color='primary'>
          {okBtnText || t('OK')}
        </Button>
        <Button onClick={() => onClose(AlertDialogResult.CANCEL)} color='primary' autoFocus>
          {cancelBtnText || t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
